import { gql } from "@apollo/client";

export const FETCH_MITIGATOR = gql`
  query GetMitigator {
    findAllMitigators {
      contactName
      email
      phone
      uuid
      vendorName
    }
  }
`;

export const CREATE_MITIGATOR = gql`
  mutation mitigator($data: CreateMitigatorInput!) {
    createMitigator(data: $data) {
      contactName
      email
      phone
      uuid
      vendorName
    }
  }
`;

export const EDIT_MITIGATOR = gql`
  mutation mitigator($data: UpdateMitigatorInput!) {
    updateMitigator(data: $data) {
      contactName
      email
      phone
      uuid
      vendorName
    }
  }
`;

export const DELETE_MITIGATOR = gql`
  mutation mitigatorRemove($uuid: ID!) {
    deleteMitigator(uuid: $uuid) {
      contactName
      email
      phone
      uuid
      vendorName
    }
  }
`;
